import { createReducer, on } from '@ngrx/store';
import { isEmpty } from 'lodash';
import { AuthActions } from './auth.actions';
import { AuthState, authState } from './auth.state';

export const authReducer = createReducer(
  authState,
  on(
    AuthActions.setProfile,
    (state, { profile }): AuthState => ({
      ...state,
      profile,
      authenticated: !isEmpty(profile)
    })
  ),
  on(
    AuthActions.activation,
    (state): AuthState => ({ ...state, authenticated: true })
  ),
  on(
    AuthActions.login,
    (state): AuthState => ({ ...state, authenticated: true })
  ),
  on(
    AuthActions.logout,
    (state): AuthState => ({ ...state, profile: {}, authenticated: false })
  )
);
